import React from 'react';

import { View, StyleSheet, TouchableOpacity, Linking } from 'react-native';

import Text from '../shared/Text';

import { MARGIN_10, MARGIN_5, pOrT, TOUCHABLE, WHITE_COLOR } from '../styleConstants';

import { COPYRIGHT_TEXT } from '../SignInScreen';

import { t } from '../../utils/appUtils';
import { IS_IOS, IS_WEB, IS_PHONE, VERSION } from '../../lib/appConstants';

import {
  DISCORD_LINK,
  PRIVACY_POLICY_LINK,
  CONTACT_EMAIL,
  APP_STORE_LINK,
  PLAY_STORE_LINK,
  REPORT_A_BUG_LINK,
  HELP_LINK,
  PATREON_LINK,
} from '../../lib/config';

const styles = StyleSheet.create({
  text: {
    fontSize: pOrT(10, 12),
    color: WHITE_COLOR,
  },
});

type LinkType = {
  name: string;
  label: string;
  link?: string;
  filter?: Function;
  email?: string;
};

export function getMenuLinks(inner: boolean = true): LinkType[] {
  return [
    {
      name: 'discord',
      label: t('help.joinChat'),
      link: DISCORD_LINK,
    },
    {
      name: 'donate',
      label: 'Donate',
      link: PATREON_LINK,
      filter: () => inner && !IS_IOS,
    },
    {
      name: 'help',
      label: t('help.help'),
      link: HELP_LINK,
      filter: () => inner,
    },
    {
      name: 'reportABug',
      label: t('help.reportABug'),
      link: REPORT_A_BUG_LINK,
      filter: () => inner || (!inner && !IS_PHONE),
    },
    {
      name: 'privacyPolicy',
      label: t('help.privacyPolicy'),
      link: PRIVACY_POLICY_LINK,
    },
    {
      name: 'contacts',
      label: t('help.contacts'),
      email: CONTACT_EMAIL,
      filter: () => !IS_PHONE,
    },
    {
      name: 'appstore',
      label: 'Apple Store App',
      link: APP_STORE_LINK,
      filter: () => inner && !IS_PHONE,
    },
    {
      name: 'playstore',
      label: 'Google Play App',
      link: PLAY_STORE_LINK,
      filter: () => inner && !IS_PHONE,
    },
  ].filter((item) => !item.filter || item.filter());
}

export function renderLinks(links: LinkType[], divide: boolean = false) {
  const renderItem = (item: LinkType, index: number, list: LinkType[]) => (
    <View key={item.name} style={{ flexDirection: 'row' }}>
      <TouchableOpacity
        hitSlop={{
          top: TOUCHABLE,
          bottom: TOUCHABLE,
          left: !index ? TOUCHABLE : 0,
          right: index === list.length - 1 ? TOUCHABLE : 0,
        }}
        onPress={() => {
          if (IS_WEB) {
            if (item.email) {
              const mail = document.createElement('a');

              mail.href = `mailto:${item.email}`;
              mail.click();
            } else {
              (window as any).open(item.link, '_blank').focus();
            }
          } else {
            Linking.openURL(item.link!);
          }
        }}
        style={{ marginLeft: 5 }}
      >
        <Text bold style={styles.text}>
          {item.label.toUpperCase()}
        </Text>
      </TouchableOpacity>
      {index !== list.length - 1 ? (
        <Text style={[styles.text, { marginLeft: 5, marginTop: -1 }]}>|</Text>
      ) : null}
    </View>
  );

  if (!divide) return links.map(renderItem);

  return (
    <View>
      <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
        {links.slice(0, Math.ceil(links.length / 2)).map(renderItem)}
      </View>
      <View
        style={{
          marginTop: MARGIN_10,
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        {links.slice(Math.ceil(links.length / 2), links.length).map(renderItem)}
      </View>
    </View>
  );
}

type FooterProps = {
  divide: boolean;
};

const Footer = ({ divide }: FooterProps) => (
  <View>
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      {renderLinks(getMenuLinks(), divide)}
    </View>
    <Text style={[styles.text, { marginTop: MARGIN_5, textAlign: 'center' }]}>
      {COPYRIGHT_TEXT} V {VERSION}
    </Text>
  </View>
);

Footer.displayName = 'Footer';

export default Footer;
